__turbopack_context__.v({
  "amount": "hero-phone-module__RTos1W__amount",
  "amountValue": "hero-phone-module__RTos1W__amountValue",
  "caret": "hero-phone-module__RTos1W__caret",
  "field": "hero-phone-module__RTos1W__field",
  "heroFieldCaret": "hero-phone-module__RTos1W__heroFieldCaret",
  "heroFieldGlow": "hero-phone-module__RTos1W__heroFieldGlow",
  "heroFieldSheen": "hero-phone-module__RTos1W__heroFieldSheen",
});
